const isValidUrl = (url: string) => {
  if (/^www\./.test(url)) {
    url = 'http://' + url
  }

  try {
    const isValidUrl = new URL(url)
    return Boolean(isValidUrl)
  } catch {
    return false
  }
}

export default isValidUrl
